import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { BulkJobError } from './BulkSearchModal';

interface BulkFailedJobsProps {
  failedJobs: BulkJobError[];
}

const BulkFailedJobs = ({ failedJobs = [] }: BulkFailedJobsProps) => {
  const renderError = () => {
    console.log("QA! If you're seeing this and this bulk order was created before 2024/05/24, ignore it.");
    return (
      <Alert severity="error" sx={{ display: 'inline-flex', pr: 3 }}>
        Something went wrong.
      </Alert>
    );
  };

  const sortedJobs = failedJobs.sort((a, b) => a.line - b.line);

  return (
    <ErrorBoundary fallbackRender={renderError}>
      <div>
        {sortedJobs.map((job) => {
          return (
            <Alert key={job.line} severity="error" sx={{ mb: 1 }}>
              <AlertTitle>Line {job.line}</AlertTitle>
              {Object.keys(job).map((key) => {
                if (key === 'line') return null;
                return (
                  <div key={key}>
                    <div>{job[key]}</div>
                  </div>
                );
              })}
            </Alert>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};

export default BulkFailedJobs;
